module.exports = __webpack_public_path__ + "web/img/sign-50.f739c66c.png";